var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-hover", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var hover = ref.hover
          return [
            _c(
              "v-btn",
              {
                directives: [
                  {
                    name: "ripple",
                    rawName: "v-ripple",
                    value: { class: "ripple-black" },
                    expression: "{ class: 'ripple-black' }",
                  },
                ],
                class: [
                  hover ? _vm.local_style.classHover : _vm.local_style.class,
                  _vm.local_is_loading ? "isLoading" : "",
                  _vm.local_only_icon ? "only-icon" : "",
                ],
                attrs: {
                  color: _vm.local_style.color,
                  height: _vm.local_is_square ? 40 : _vm.local_style.height,
                  width: _vm.local_only_icon ? 40 : "",
                  "min-width": _vm.local_only_icon ? 40 : "",
                  block: _vm.local_is_block,
                  disabled: _vm.local_is_disabled,
                  text: _vm.local_style.isText,
                  href: _vm.local_href,
                  elevation: "0",
                  type: _vm.local_button_type,
                },
                on: { click: _vm.onClick },
              },
              [
                !_vm.local_only_text
                  ? _c(
                      "span",
                      {
                        class: [
                          "icon-container",
                          _vm.local_is_tiny_icon ? "tiny" : "",
                        ],
                      },
                      [
                        _c("i", { class: _vm.local_icon }),
                        _vm._v(" "),
                        _c("v-progress-circular", {
                          staticClass: "loader",
                          attrs: {
                            indeterminate: true,
                            rotate: 0,
                            size: 16,
                            value: 0,
                            width: 2,
                            color: "#2e3a46",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  { class: ["text", _vm.local_only_icon ? "d-none" : ""] },
                  [_vm._v(_vm._s(_vm.local_text))]
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }